import React from 'react';
export const MockExamScheduleDatetime = (
  props: React.HTMLProps<HTMLDivElement>,
) => (
  <div
    {...props}
    className="flex justify-start items-center text-neutral-dust text-sm leading-5 max-sm:text-xs"
  >
    {props.children}
  </div>
);

export const MockExamScheduleDate = (
  props: React.HTMLProps<HTMLDivElement>,
) => (
  <div {...props} className="flex justify-start items-center [&_span]:pl-1">
    {props.children}
  </div>
);
